import { newBlockID } from '../../model';
export const DelimiterPluginID = 'delimiter';
export function newDelimBlock(kind = 'simple', id) {
    return {
        id: id || newBlockID(),
        kind,
        plugin: DelimiterPluginID
    };
}
